<template lang="pug">
  div
    section.content-header
      h1 CSVから一括登録

    section.content

      app-messages(
        :errorTitleMessage="importErrorTitle",
        :errorMessages="importErrors",
        :successTitleMessage="importSuccessTitle",
        :successMessages="importSuccesses",
        :infoIconClass="'icon fa fa-spinner fa-pulse'",
        :infoTitleMessage="importInfoTitle",
        :infoMessages="importMessages"
      )

      .callout.callout-info.bcard-callout
        h4(v-if="isMgmt") 名刺情報をCSVファイルから一括で登録します。
        h4(v-else) 自分が交換した名刺をCSVファイルから一括で登録します。
        ul
          li サンプルCSVファイルをダウンロードし、内容を変更してアップロードしてください。
          li タイトル行に*印のついた項目（公開区分、姓、姓（よみがな）、会社名、会社名（よみがな）、名刺交換日）は必須入力です。

      .row
        .col-xs-6
          .info-box
            span.info-box-icon.bg-yellow
              i.fa.fa-file-o
            .info-box-content
              span.info-box-text(title="タイトル行のみ書かれたCSVファイル") タイトル行のみ書かれたCSVファイル
              span.info-box-number タイトルCSV
              a.btn.btn-default.pull-right(href='static/files/addcard/sample-addcard-title.csv' download="sample-addcard-title.csv" target="_blank")
                | ダウンロード
                i.fa.fa-download

        .col-xs-6
          .info-box
            span.info-box-icon.bg-green
              i.fa.fa-file-text-o
            .info-box-content
              span.info-box-text(title="タイトル行とサンプル行が書かれたCSVファイル") タイトル行とサンプル行が書かれたCSVファイル
              span.info-box-number サンプルCSV
              a.btn.btn-default.pull-right(href='static/files/addcard/sample-addcard-data.csv' download="sample-addcard-data.csv" target="_blank")
                | ダウンロード
                i.fa.fa-download

      //- ロック中は表示しない
      form(ref="form", @submit.prevent="postData(true)", novalidate)
        .box.box-widget(v-if="isUploadAvailable")
          .box-body
            .form-horizontal
              import-settings(v-model="importSettings", ref="importSettings")
              .form-group
                label.col-sm-3.control-label(for="update_data") 上書き更新
                .col-sm-9
                  .radio.radio-rich
                    label
                      input(type="radio" name="update_data", :value="app_flag.ON")
                      span: i.fa.fa-dot-circle-o.fa-lg
                      | する
                    |
                    | &nbsp;
                    |
                    label
                      input(type="radio" name="update_data", :value="app_flag.OFF", checked)
                      span: i.fa.fa-dot-circle-o.fa-lg
                      | しない (すべて新規登録する)
                  .help-block(style="margin: 1em 0 0;")
                    p.bcard-comments.text-info ※ 「する」を選択した場合、以下のデータがすべて一致したデータを上書き更新します。
                      br
                      | 同じCSVファイル内にあるデータも、一致した行は上書きされます。
                    ul.bcard-comments.text-info
                      li 姓（よみがな）
                      li 名（よみがな）
                      li 会社名（よみがな）
                      li 名刺交換者ログインID
                      li 名刺交換日
                    p.bcard-comments.text-info ※ 重複した既存の名刺の名刺交換者が 1 名 であり、かつその名刺の名刺人物にほかの名刺が存在しない場合に限り、存在した名刺情報をすべて上書きします。それ以外は新規登録になります。
            p.bcard-required ※ (*)は必須項目です。

          .box-footer.text-right
            button.btn.btn-primary(type="submit") アップロード

    section.content-header
      h2 登録状況一覧

    section.content

      app-messages(
        :errorMessages="listErrors",
        :successMessages="listSuccesses"
      )

      .panel.panel-default
        .panel-heading
          .row
            .col-sm-4
              button.btn.btn-danger(v-if="list.length > 0" type="button", @click="confDelete") 削除
            .col-sm-8.text-right
              span.btn.btn-primary(v-if="isLoading", title="読み込み中")
                i.fa.fa-refresh.fa-spin
              a.btn.btn-primary(v-else, title="再読み込み", @click.prevent="reload")
                i.fa.fa-refresh

        loading(v-if="isLoading")
        .table-responsive(v-else-if="list.length > 0")
          table.table.table-striped.table-bordered.bcard-table
            thead
              tr
                th.bcard-table-td-chk
                  input(type="checkbox" @change="checkAll(list, $event.target.checked)")
                th.bcard-table-td-ymdhi
                  i.fa.fa-sort-desc.bcard-table-sort-header-icon
                  | アップロード日時
                th.bcard-table-td-card-status 状況
                th.bcard-table-td-filename ファイル名
                th.bcard-table-td-cnt 処理件数
                th.bcard-table-td-updcnt 上書き更新 / 件数
            tbody
              tr(v-for="item in list", :key="item.id", :class="{'selected': isChecked(item.id) && isDone(item)}")
                td.bcard-table-td-chk
                  input(v-if="isDone(item)",
                    type="checkbox",
                    :checked="isChecked(item.id)",
                    @change="checkItem(item.id, $event.target.checked)"
                  )
                td.text-ymdhi {{item.formatted_uploadtime}}
                td
                  template(v-if="isError(item)")
                    i.fa.fa-fw.fa-exclamation-triangle.fa-fw.text-red
                    a(href="#", title="エラー詳細を見る", @click.prevent="modalUploadErrMsg_open(item.msgdetail)")
                      | {{item.lang_status}}
                  template(v-else)
                    i.fa.fa-fw.fa-clock-o(v-if="item.isChecking || item.isRegisting")
                    i.fa.fa-fw.fa-check.fa-fw.text-yellow(v-else-if="item.isCompleted")
                    | {{item.lang_status}}
                td.bcard-ui-userdata(:title="item.filename") {{item.filename}}
                td.text-right {{item.datacnt}}
                td
                  span(v-if="item.update_data === app_flag.ON") する / {{item.updatecnt}} 件
                  span(v-else) しない

        .panel-body.text-center(v-else) データがありません。

      .callout.callout-info.bcard-callout
        .callout-header 注意事項
        ol
          li エラーチェックを行い、エラーがなければ自動的に登録されます。
          li エラーがあった場合
            ul
              li エラー内容を確認し、CSVファイルを修正の上、もう一度アップロードしてください。
              li エラーがなくなるまで登録処理は行われません。
              li （行単位でエラーチェックを行い、エラーがあった場合には以降の行のチェックは行いません。）
          li CSVファイルの「名刺交換日」の列には、以下のいずれかの形式で存在する日付を入力してください。
            ul
              li
                code "2006-12-27"
                code "2006 12 27"
                code "2006.12.27"
                code "2006/12/27"
                code "20061227"
                br
                code "06-12-27"
                code "06 12 27"
                code "06.12.27"
                code "06/12/27"
                code "061227"
              li また、名刺交換日には「1990/01/01」より後の日付を入力してください。
              li （未来の日付は入力できません。）
          //- 一般モード
          li(v-if="!isMgmt") CSVファイルの「名刺交換者ログインID」の列には、何も設定しないか、自身のログインIDを設定してください。
            ul
              li 何も設定しない場合、実行ユーザーが名刺交換者として登録されます。
              li それ以外の場合はエラーとなります。
          //- 管理モード
          li(v-else) CSVファイルの「名刺交換者ログインID」の列には、何も設定しないか、存在するユーザーのログインIDを設定してください。
            ul
              li 何も設定しない場合、「システム設定ユーザー」（規定のシステム管理者ユーザー）が名刺交換者として登録されます。
              li （システム設定ユーザーの名刺交換時情報は、名刺管理機能で変更可能です。）
              li それ以外の場合はエラーとなります。
          li CSVファイルの「年代」の列には、以下のいずれかの値を入力してください。
            ul
              li
                code "10"
                code "20"
                code "30"
                code "40"
                code "50"
                code "60"
                code "70"
          li CSVファイルの「タグ1～{{NUM_BCARD_IMPORT_TAG}}」の列には、存在するタグ名を入力してください。
            ul
              //- 一般モード
              li(v-if="!isMgmt") 存在しないタグ名を入力した場合は、新しい個人タグが作成され、その個人タグが名刺人物に追加されます。
              //- 管理モード
              li(v-else) 存在しないタグ名を入力した場合は、名刺交換者の新しい個人タグが作成され、その個人タグが名刺人物に追加されます。

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    app-modal(type="danger", v-model="modalDeleteLogsConf_isOpen")
      template(slot="title") 登録状況の削除
      h4 選択した登録状況を削除します。よろしいですか？
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-danger(@click="close(); deleteCsvsLogs();") 削除
        button.btn.btn-default(@click="close") キャンセル

    app-modal(type="info", v-model="modalDeleteLogsNone_isOpen")
      h4 削除する登録状況を選択してください

    //- アップロード中モーダル
    app-modal(type="info", v-model="modalUploading_isOpen")
      template(slot="title") アップロード中
      h4
        i.icon.fa.fa-spinner.fa-pulse
        | &nbsp;ただいまCSVファイルをアップロード中です。
      p 処理が終わるまでしばらくお待ちください。

    //- アップロードエラーモーダル
    app-modal(type="warning", v-model="modalUploadErrMsg_isOpen")
      template(slot="title") エラー
      div
        p(v-for="message in modalUploadErrMsg_msgdetail") {{message}}
</template>

<script>
import mixinList from '@/mixins/list'
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import ImportSettings from '@/components/organisms/ImportSettings'
import Loading from '@/components/molecules/Loading'
import mixinForm from '@/mixins/form'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const CardRepository = RepositoryFactory.get('newbcard')

export default {
  name: 'BcardCsv',
  components: { AppModal, AppMessages, ImportSettings, Loading },
  mixins: [ mixinList, mixinForm ],
  data: function () {
    return {
      isLoading: true,
      importErrorTitle: '',
      importErrors: [],
      importSuccessTitle: '',
      importSuccesses: [],
      importInfoTitle: '',
      importMessages: [],
      listErrors: [],
      listSuccesses: [],

      isUploadAvailable: false, // ロック中は使えないのでフラグを用意する
      importSettings: {
        csvFile: null
      },
      // 結果取得フラグ
      isGodResult: null, // 初期値：null, 取得完了：true, 取得中：false

      // 確認モーダル
      modalDeleteLogsConf_isOpen: false,
      modalDeleteLogsNone_isOpen: false,
      // アップロード中モーダル
      modalUploading_isOpen: false,
      // アップロードエラーモーダル
      modalUploadErrMsg_isOpen: false,
      modalUploadErrMsg_msgdetail: ''
    }
  },
  computed: {
    apiQuery: function () {
      // APIのURLに機能管理モードフラグを付与する
      return this.isMgmt ? '?is_mgmt=1' : ''
    },
    NUM_BCARD_IMPORT_TAG () {
      return this.loadConfigEnv('NUM_BCARD_IMPORT_TAG')
    }
  },
  created: function () {
    // 画面を初期化する
    this._initPage()
  },
  methods: {
    /**
     * 画面の初期化処理
     */
    _initPage: function () {
      this.importInfoTitle = 'アップロード状況を確認しています。'
      this.importMessages.push('しばらくお待ちください。')

      // 処理結果取得
      this.getResult(false)

      // 登録状況一覧取得
      this.reload()
    },
    _clearMessages: function () {
      this.clearMessages()
      this.importErrorTitle = ''
      this.importErrors = []
      this.importSuccessTitle = ''
      this.importSuccesses = []
      this.importInfoTitle = ''
      this.importMessages = []
      this.listErrors = []
      this.listSuccesses = []
    },
    /**
     * CSVファイルをアップロードする
     * @param {boolean} fromSubmit サブミットフラグ
     */
    postData: function (fromSubmit) {
      const vm = this
      vm._clearMessages()

      if (!vm.checkFormValidity()) {
        vm.importErrors = vm.errors
        return
      }

      // アップロード中モーダルを開く
      vm.modalUploading_isOpen = true
      // 続けてアップロードできないようにする
      vm.isUploadAvailable = false

      vm.importInfoTitle = 'アップロード処理を実行中です。'
      vm.importMessages.push('しばらく時間を空けてから再度実行してください。')

      // 登録内容
      let bcardFormData = new FormData(this.$refs.form)

      // FileListからFileを削除するための苦肉の策
      bcardFormData = this.appendFiles(bcardFormData, true)

      // API実行
      CardRepository.postBcardCsvs(bcardFormData, this.isMgmt)
        // 成功時処理
        .then(function (response) {
          // アップロード中モーダルを閉じる
          vm.modalUploading_isOpen = false
          // 登録状況一覧をリロードする
          vm.reload()

          // 処理結果取得
          vm.getResult(fromSubmit)
        })
        // システムエラー
        .catch(function (error) {
          // アップロード中モーダルを閉じる
          vm.modalUploading_isOpen = false
          // 別のファイルをアップロードできるようにする
          vm.isUploadAvailable = true
          // メッセージ入れ替え
          vm._clearMessages()
          vm.setErrorMessage(error)
          vm.importErrors = vm.errors
        })

      // ExportSettingsのsaveCookie()を呼び出す
      this.$refs.importSettings.$refs.exportSettings.saveCookie()

      window.scrollTo(0, 0)
    },
    getList: function (options) {
      const vm = this
      this.isLoading = true

      // 検索パラメーター
      let params = {
        page: options.page || 1
      }

      // API実行
      this.sendListRequest({
        repo: this.isMgmt ? 'managebcard' : 'newbcard',
        method: 'getBcardCsvs',
        params: params,
        onSuccess: function (response) {
          vm.isLoading = false
        },
        onError: function (response) {
          vm.listErrors = vm.errors
        }
      })
    },
    reload: function () {
      this.getList({page: this.pagination.current_page || 1})
    },
    confDelete: function () {
      if (this.hasCheckedItems()) {
        this.modalDeleteLogsConf_isOpen = true
      }
      else {
        this.modalDeleteLogsNone_isOpen = true
      }
    },
    deleteCsvsLogs: function () {
      const vm = this
      this._clearMessages()
      this.sendBulkRequest('newbcard', 'bulkDeleteBcardCsvs', {
        params: {
          id: this.checkedIds,
          isMgmt: this.isMgmt
        },
        onSuccess: function (response) {
          vm.listSuccesses = vm.successes
        },
        onError: function (response) {
          vm.listErrors = vm.errors
        }
      })
    },
    /**
     * アップロードエラーモーダルを表示する
     */
    modalUploadErrMsg_open: function (msgdetail) {
      this.modalUploadErrMsg_msgdetail = msgdetail.split('\n')
      this.modalUploadErrMsg_isOpen = true
    },
    /**
     * 前回のアップロードの処理結果を取得する
     * @param {boolean} fromSubmit
     */
    getResult: function (fromSubmit) {
      const vm = this
      const getResult = setInterval(function () {
        // 前回の結果取得が終わっていない場合、結果取得を行わない
        if (vm.isGodResult === false) {
          return
        }

        // 結果取得フラグをオフにする
        vm.isGodResult = false
        CardRepository.getBcardCsvsUploadResult(this.isMgmt)
          // 成功時処理
          .then(function (response) {
            let data = vm.getApiData(response)
            const infoMessage = 'アップロード処理を実行中です。'
            const successMessage = 'アップロード処理が完了しました。'
            const errorMessage = 'アップロード処理が失敗しました。'

            // アップロード中の場合、次のファイルをアップロードできないようにする
            vm.isUploadAvailable = (data.status !== 'active')
            vm._clearMessages()
            if (vm.isApiSuccess(response)) {
              if (data.status === 'active') {
                vm.importInfoTitle = fromSubmit ? infoMessage : '前回の' + infoMessage
                vm.importMessages.push('しばらく時間を空けてから再度実行してください。')
              }
              else if (data.status === 'finish') {
                vm.importSuccessTitle = fromSubmit ? successMessage : '前回の' + successMessage
                vm.importSuccesses.push('詳細は登録状況一覧を確認してください。')
              }
            }
            // アプリエラー
            else {
              vm.isUploadAvailable = true
              vm.importErrorTitle = fromSubmit ? errorMessage : '前回の' + errorMessage
              vm.importErrors.push(data.message)
            }

            if (vm.isUploadAvailable) {
              vm.reload()
              clearInterval(getResult)
            }
          })
          // システムエラー
          .catch(function (error) {
            // メッセージ入れ替え
            vm._clearMessages()
            vm.setErrorMessage(error)
            vm.importErrors = vm.errors
            clearInterval(getResult)
          })
          .finally(function () {
            // 結果取得フラグをオンにする
            vm.isGodResult = true
          })
      }, this.app_interval.getResult)
      this.$store.commit('setIntervals', getResult)
    },
    /**
     * インポートが完了したかどうか
     * @param item object 項目
     * @return 削除可能かどうか
     */
    isDone: function (item) {
      return this.isError(item) || item.isCompleted
    },
    /**
     * エラーかどうか
     * @param item object 項目
     * @return エラーかどうか
     */
    isError: function (item) {
      return item.isCheckError || item.isRegistError || item.isSysError
    }
  }
}
</script>

<style lang="scss" scoped>
.nodate {
  text-align: center;
  line-height: 5em;
  border-top: 1px solid #ccc;
}
.bcard-table-td-cnt {
  width: 5em;
}
.bcard-table-td-updcnt {
  width: 9em;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/bcardcsv/Index.vue